<template>
  <div class="container retailers-widget">
    <div class="error-message">{{retailersError}}</div>
    <div v-if="!retailersTags || !retailersTags.length" class="empty-response">no matching retailers</div>
    <div v-else class="retailers-widget-wrapper">
      <div :class="['retailers-container', 'flip-scrollbar-parent', retailerTagsListOpen ? 'slide-out' : 'slide-in']">
        <div class="retailers-wrapper flip-scrollbar-child">
          <div v-for="retailer in retailersTags" class="retailer-group" :key="retailer.id" @click="getRetailerTags(retailer.id, retailer.name)">
            <div class="retailer-group-text">{{retailer.name}}</div>
          </div>
        </div>
      </div>
      <div :class="['pos-tags-container', 'flip-scrollbar-parent', retailerTagsListOpen ? 'slide-in' : 'slide-out']">
        <div class="pos-tags-wrapper flip-scrollbar-child">
          <loading-icon v-if="retailerTagsLoading"></loading-icon>
          <div v-else :class="['tags-wrapper']">
            <div class="back-link-wrapper" @click="closeTagsList">
              <div class="back-link"><span class="back-text">back</span></div>
            </div>
            <div class="sub-header">{{selectedRetailer}}</div>
            <div v-if="tagsError" class="error-message">{{tagsError}}</div>
            <div v-else>
              <div v-for="tag in retailerTagsList" :key="tag.id">
                <tag :tag="tag" :advertiserId="advertiserId" @refreshAllSections="refreshAllSections" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import LoadingIcon from '../Shared/LoadingIcon'
  import Tag from './Tag'

  export default {
    props: {
      retailersTags: Array,
      retailersError: String,
      advertiserId: [Number, String]
    },

    name: 'RetailerTagsWidget',

    components: {
      LoadingIcon,
      Tag
    },

    data() {
      return {
        retailerTagsList: null,
        retailerTagsListOpen: null,
        retailerTagsLoading: false,
        selectedRetailer: null,
        tagsError: null,
      }
    },

    methods: {
      closeTagsList() {
        this.retailerTagsListOpen = false
      },

      getRetailerTags(id, name) {
        this.retailerTagsLoading = true
        this.retailerTagsListOpen = true
        this.selectedRetailer = name

        const view = this,
          url = `/merchants/${id}/linked_tags?brand_id=${this.advertiserId}`

        this.$api.get(url)
          .then((response) => {
            const data = response.data
            if (data) {
              view.retailerTagsList = data
              view.tagsError = null
            } else {
              view.suggestionsError = 'there was an error loading tags, please refresh or contact support'
            }
            view.retailerTagsLoading = false
          })
          .catch((error) => {
            view.tagsError = `there was an issue: ${error}`
            view.retailerTagsLoading = false
          })
      },

      refreshAllSections(sectionToSkip) {
        this.$emit('refreshAllSections', sectionToSkip)
      }
    },
  }
</script>

<style lang="sass">
@import '../../assets/sass/colors'

.retailers-widget
  .header
    margin-top: 1rem

  .retailers-widget-wrapper
    display: flex
    margin-top: 1rem
    overflow-x: hidden
    padding: 0 1rem


  .retailers-container, .pos-tags-container
    flex-basis: 100%
    min-width: 100%
    max-height: 250px
    max-width: 800px
    opacity: 1
    overflow-x: hidden
    overflow-y: scroll
    transition: all .7s ease

  .retailers-container
    min-width: 90%
    min-width: -webkit-fill-available
    min-width: -moz-available

    &.slide-out
      max-width: 0
      opacity: 0
      transform: scaleX(-1) translateX(100%)
      visibility: hidden

      .retailers-wrapper
        max-width: 0

  .pos-tags-container
    &.slide-in
      transform: scaleX(-1) translateX(98%)

    &.slide-out
      max-width: 0
      opacity: 0
      visibility: hidden
      .pos-tags-wrapper
        max-width: 0

  .retailers-wrapper
    padding: 0 1rem
    width: 100%

  .retailer-group:first-child
    .retailer-group-text
      padding-top: 0

    &:after
      margin: 2px 10px 0 0

  .retailer-group
    border-bottom: 1px solid $primary-color
    cursor: pointer
    display: flex
    justify-content: space-between

    .retailer-group-text
      padding: .85rem 1rem
      text-align: left
      width: 100%

    &:after
      border-bottom: 1px solid $primary-color
      border-right: 1px solid $primary-color
      content: ' '
      display: inline-block
      height: 10px
      margin: 15px 10px 0 0
      transform: rotate(-45deg)
      width: 10px

  .sub-header
    font-size: 1rem
    margin: .5rem auto

  .back-link-wrapper
    color: $primary-color
    cursor: pointer

    .back-link
      align-items: center
      display: flex

      &:before
        border-bottom: 1px solid $primary-color
        border-right: 1px solid $primary-color
        content: ' '
        display: inline-block
        height: 6px
        margin: 0 5px 0 19px
        transform: rotate(135deg)
        width: 6px
</style>